export default () => {

    const collapseItem = document.querySelectorAll('.collapse-listener');

    function addClassToParent(element, className) {
        element.parentNode.classList.add(className);
    };

    function removeClassToParent(element, className) {
        element.parentNode.classList.remove(className);
    };

    collapseItem.forEach(function(collapse) {
        collapse.addEventListener('show.bs.collapse', function (event) {
            addClassToParent(event.target, 'collapsed');
        });

        collapse.addEventListener('hide.bs.collapse', function (event) {
            removeClassToParent(event.target, 'collapsed');
        });
    })
}
  